import { FC } from "react";

import styled from "styled-components";
import SpinnerIcon from "./spinner.svg";

interface SpinnerProps {
  size?: number;
}

const Spinner: FC<SpinnerProps> = ({ size }) => {
  return (
    <SpinnerWrapper>
      <img alt="spinner" src={SpinnerIcon} height={`${size || 100}px`} />
    </SpinnerWrapper>
  );
};

const SpinnerWrapper = styled.div`
  display: flex;
  margin-left: 8px;
`;

export default Spinner;
